import type { VariantProps } from 'class-variance-authority'
import { createContext } from 'react'

import { itemVariants } from './item.variants.ts'

export type ItemSize = NonNullable<VariantProps<typeof itemVariants>['size']>

export type ItemGroupContextValue = {
  size: ItemSize
  surfaceOwner: 'group'
}

export const ItemGroupContext = createContext<ItemGroupContextValue | undefined>(undefined)
